import { DaoModel } from '@dynameat/models';
import { User } from './user';

export class UserRole extends DaoModel {
  constructor(role, roleLevel, user, availableFrontGroups, allowedPointsGfSales) {
    super();
    this.role = role;
    this.roleLevel = roleLevel;
    this.user = user;
    this.availableFrontGroups = availableFrontGroups || [];
    this.allowedPointsOfSales = allowedPointsGfSales || [];
  }

  static toInstance(props = {}) {
    const user = User.toInstance(props.user);
    return new UserRole(props.role, props.role_level, user, props.available_front_groups, props.allowed_points_of_sales);
  }

  serialize() {
    return {
      role: this.role,
      role_level: this.roleLevel,
      user: this.user.serialize(),
      available_front_groups: this.availableFrontGroups,
      allowed_points_of_sales: this.allowedPointsOfSales,
    };
  }
}
